import React, { useState } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { Button as ReactButton } from 'react-bootstrap';

import styles from './TestSMTPSendMailPopup.module.css';
import { httpPost } from '../../../utils';

const TestSMTPSendMailPopup = ({ onCancel }) => {
    const [mail, setMail] = useState('');
    const [testResults, setTestResults] = useState({ text: '', error: false });
    const [isDuringTest, setIsDuringTest] = useState(false);

    const sendTest = async () => {
        try {
            setIsDuringTest(true);
            setTestResults({ text: `Sending Email to ${mail}...`, error: false });
            await httpPost(`/settings/testSMTP`, { email: mail });

            setTestResults({ text: 'Email was sent successfully', error: false });
            setIsDuringTest(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.data && err.response.data.error) {
                setTestResults({ text: err.response.data.error, error: true });
            } else {
                setTestResults({ text: 'Something went wrong.', error: true });
            }
            setIsDuringTest(false);
        }
    };

    return (
        <Modal dialogClassName={styles.dialogStyle} show onHide={onCancel} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{`Test SMTP SERVER`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.selectedUserHeader}>
                    <div className={styles.selectedUserTitle}>Email Address:</div>
                    <div>
                        <input className={styles.mailInput} onChange={(e) => setMail(e.target.value)} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className={`${styles.footerMsg} ${testResults.error ? styles.errorFooterMsg : ''}`}>
                    {testResults.text}
                </div>
                <ReactButton onClick={onCancel}>Cancel</ReactButton>
                <ReactButton disabled={!mail || isDuringTest} bsStyle="success" onClick={sendTest}>
                    {isDuringTest ? 'Sending...' : 'Send Email'}
                </ReactButton>
            </Modal.Footer>
        </Modal>
    );
};

export default TestSMTPSendMailPopup;
